import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ArticleEditorBlock as Data } from '../../../graphql/generated/api-graphql';
import ArticleBlock, { ArticleBlockProps } from '../../../components/molecules/ArticleBlock';
import { wediaImagesTransform } from '../../Common/wedia';
import { VideoProps } from '../../../components/atoms/Video';
import Router from '../../../routes/Router';
import routes from '../../../routes/definitions';
import { fixURL } from '../../../helpers/StringHelpers';
import { HtmlLayout } from '../../../components/atoms/Html/types';
export type ArticleEditorBlockProps = {
  data: Data & {
    anchor: string;
  };
};
const ArticleEditorBlock: FC<ArticleEditorBlockProps> = ({
  data
}) => {
  const {
    t
  } = useTranslation();
  const props: ArticleBlockProps = {
    title: data?.title ?? undefined,
    htmlTitleTag: 'h3',
    anchor: data.anchor,
    htmlProps: data?.description ? {
      text: fixURL(data.description),
      layout: HtmlLayout.article
    } : undefined,
    pictureProps: data?.imageDesktop ? {
      maxWidth: 910,
      withHD: true,
      alt: data.imageDesktop.alt ?? '',
      images: [...(data?.imageDesktop ? wediaImagesTransform(data?.imageDesktop) ?? [] : [])].filter(Boolean)
    } : data?.recipe?.thumbnail01 ? {
      maxWidth: 910,
      withHD: true,
      alt: data.recipe.thumbnail01.alt ?? '',
      images: [...(data?.recipe?.thumbnail01 ? wediaImagesTransform(data?.recipe?.thumbnail01) ?? [] : [])].filter(Boolean)
    } : undefined,
    videoProps: data?.video?.sources ? {
      sources: data?.video?.sources.map(source => {
        return source.source ? {
          src: source.source,
          type: source.mimeType
        } : undefined;
      }).filter(Boolean),
      jsonLdInfo: {
        name: data?.title ?? undefined
      },
      controls: true
    } as VideoProps : undefined,
    buttons: [...(data?.cheese?.slug ? [{
      label: t('learn_more'),
      href: Router.getRouteUrl(routes.cheese, {
        slug: data.cheese.slug
      })
    }] : []), ...(data?.recipe?.slug ? [{
      label: t('article_view_recipe'),
      href: Router.getRouteUrl(routes.recipe, {
        slug: data.recipe.slug
      })
    }] : [])]
  };
  return <ArticleBlock {...props} />;
};
export default ArticleEditorBlock;